import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiPost } from 'api-service';
import {
  setOnboardingInitialValues,
  setUserId,
  updateOnboardingSettings,
} from 'store/onboarding/onboardingSlice';
import { fetchWebsiteSettings } from 'store/settings/settingsSlice';
import { fetchQueries } from 'store/page/actions';
import { fetchShepherdSettings } from 'store/shepherd/shepherdSlice';
import { persistor } from 'store';
import { setCurrentUser, clearCurrentUser } from 'store/account/account.slice';
import { resetAccount } from 'utils';

export const registerUser = createAsyncThunk(
  'authReducer/registerUser',
  async (params, thunkAPI) => {
    try {
      const response = await apiPost('/user/registerWithMobileNumber', params);
      thunkAPI.dispatch(setUserId(response?.data?.result?.userId));
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const loginUser = createAsyncThunk(
  'authReducer/loginUser',
  async (params, thunkAPI) => {
    try {
      let { currentUser } = thunkAPI.getState().userReducer;
      if (params) {
        const response = await apiPost('/user/login', params);
        resetAccount();
        currentUser = response.data;
      }
      if (!currentUser?.is_verified_user) {
        return {
          currentUser: currentUser?.result,
        };
      }
      if (currentUser?.password_expired) {
        thunkAPI.dispatch(setCurrentUser({ currentUser }));
        return { currentUser };
      }
      thunkAPI.dispatch(setCurrentUser({ currentUser }));
      const queries = await thunkAPI.dispatch(fetchQueries()).unwrap();
      await thunkAPI.dispatch(
        fetchWebsiteSettings({ shouldApplyToOtherReducers: true })
      );
      await thunkAPI.dispatch(fetchShepherdSettings());
      return { currentUser, queries };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const logoutUser = createAsyncThunk(
  'authReducer/logoutUser',
  async (_, thunkAPI) => {
    try {
      const response = await apiPost('/user/logout');
      thunkAPI.dispatch(clearCurrentUser());
      persistor.flush();
      thunkAPI.dispatch({
        type: 'USER_LOGOUT',
      });
      persistor.persist();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const verifyUserMobileNumber = createAsyncThunk(
  'authReducer/verifyUserMobileNumber',
  async (params, thunkAPI) => {
    try {
      const response = await apiPost('/user/checkMobileCode', params);
      const {
        permissions,
        same_company_departments,
        user_settings,
        notification_settings,
        presets,
        profile_data,
        ...user
      } = response?.data?.user;
      thunkAPI.dispatch(setCurrentUser({ currentUser: response?.data }));
      thunkAPI.dispatch(
        setOnboardingInitialValues({
          user: user,
        })
      );
      thunkAPI.dispatch(
        updateOnboardingSettings({
          key: 'onboarding_settings.user',
          value: {
            ...user,
          },
        })
      );
      await thunkAPI.dispatch(
        fetchWebsiteSettings({ shouldApplyToOtherReducers: true })
      );
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
